var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","background-color":"#FFF","padding":"20px 0"}},[_c('ele-chart',{staticStyle:{"height":"600px","width":"100%"},attrs:{"option":_vm.visitHourChartOption}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }